@if (switchControl(); as switch) {
  <osp-input-switch [formControl]="switch" size="small" />
}
<label class="label-container overflow-hidden" [for]="$for()">
  <span
    class="text-color-secondary font-medium overflow-hidden text-overflow-ellipsis white-space-nowrap"
    textColor="secondary"
  >
    <ng-content></ng-content>
    @if ($isRequired()) {
      *
    }
  </span>

  <span additional-label class="text-color-secondary font-normal text-xs" textColor="secondary">
    <ng-content select="[additional-label]"></ng-content>
  </span>
</label>
@if (tooltip()) {
  <osp-tooltip-icon [tooltipText]="tooltip()" iconSize="small" />
}
